export default __webpack_public_path__ + "static/media/template2.c712c943.png";